/** @jsxImportSource @emotion/react */
import twitterGradientSVG from "assets/images/twitter_gradient.svg";
import grouphugSVG from "assets/images/grouphug.svg";
import hedgehugSVG from "assets/images/hedgehug.svg";
import hughubSVG from "assets/images/hughub.svg";
import { themePrototype } from "styles/themePrototype";
import { Callout, H2, H3, Link, Text } from "atoms";
import { constants } from "config";

const css = {
  textAlign: "center",
  "& > div": {
    "div + div": {
      marginTop: "4rem",
    },
    "@media (min-width: 860px)": {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      textAlign: "left",
      div: {
        width: "45%",
      },
      "div + div": {
        margin: 0,
      },
    },
  },
  title: {
    fontSize: themePrototype.fontSizes.h1,
  },
  SubTitle: {
    fontSize: themePrototype.fontSizes.h2,
  },
  "h2 + p": {
    marginBottom: "3rem",
  },
  p: {
    marginBottom: "1.5rem",
  },
  "div > img": {
    marginBottom: "1rem",
  },
  img: {
    height: "50px",
  },
} as const;

type SocialCalloutProps = {
  variant:
    | "HUGhub"
    | "groupHUG"
    | "hedgeHUG"
    | "Artist In Residence"
    | "Development Studio";
};

const variantOpts = (variant: string) => {
  if (
    variant === "HUGhub" ||
    variant === "Artist In Residence" ||
    variant === "Development Studio"
  ) {
    return {
      img: hughubSVG,
      cta: "Mint Now",
      message: "Join with a membership pass.",
      path: "/mint",
    };
  }
  if (variant === "groupHUG") {
    return {
      img: grouphugSVG,
      message: "Join in on the groupHUG. Applications close April 30.",
      cta: "Apply",
      href: constants.groupHugApplication,
    };
  }
  return {
    img: hedgehugSVG,
    message: "Become a hedgeHUG. Applications close April 30.",
    cta: "Apply",
    href: constants.hedgeHugApplication,
  };
};

function SocialCallout({ variant }: SocialCalloutProps) {
  const { img, cta, message, path, href } = variantOpts(variant);
  return (
    <Callout css={css}>
      <H2 css={css.title}>Want to get started?</H2>
      <Text size="lg">
        <Link to="/faq">Check our FAQs</Link> to learn more.
      </Text>

      <div>
        <div>
          <img src={twitterGradientSVG} alt="" />
          <H3 css={css.SubTitle}>Twitter</H3>
          <Text size="lg">Follow along for the latest updates.</Text>
          <Link href={constants.twitterURL} variant="gradient" arrow="dr">
            Visit Twitter
          </Link>
        </div>
        <div>
          <img src={img} alt="" />
          <H3 css={css.SubTitle}>{cta}</H3>
          <Text size="lg">{message}</Text>
          {path && (
            <Link to={path} variant="gradient" arrow="dr">
              {cta}
            </Link>
          )}
          {href && new Date() < new Date("2022-05-01") && (
            <Link href={href} variant="gradient" arrow="dr">
              {cta}
            </Link>
          )}
        </div>
      </div>
    </Callout>
  );
}

export { SocialCallout };
